import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Helmet } from "react-helmet";
import SearchDropdown from "../../../../../../search/seatchDropdown";

function CreateIntegration({ chimeraserv, user }) {
  const [groups, setGroups] = useState([]);
  const [brands, setBrands] = useState([]);
  const [outlets, setOutlets] = useState([]);
  const [form, setForm] = useState({
    group: { value: "", state: null },
    brand: { value: "", state: null },
    name: { value: "", state: null },
    vendorCountry: { value: "", state: null },
    vendorID: { value: "", state: null },
    vendorName: { value: "", state: null },
    message: { value: "", state: null },
    state: false,
  });
  const [groupSearchTerm, setGroupSearchTerm] = useState("");
  const [filteredGroups, setFilteredGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [outletStores, setOutletStores] = useState([
    { chaKey: "", storeNum: "" },
  ]);
  const groupDropdownRef = useRef(null);

  const headers = {
    Authorization: user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const response = await axios.get(chimeraserv.urlGet + "/group", {
          headers,
        });
        setGroups(response.data);
        setFilteredGroups(response.data);
      } catch (error) {
        setGroups([]);
        setFilteredGroups([]);
      }
    };
    fetchGroups();
  }, [chimeraserv.urlGet, user.data.usrKey]);

  useEffect(() => {
    if (!groupSearchTerm) {
      setFilteredGroups(groups);
    } else {
      setFilteredGroups(
        groups.filter(
          (group) =>
            group.name.toLowerCase().includes(groupSearchTerm.toLowerCase()) ||
            group.grpKey.toLowerCase().includes(groupSearchTerm.toLowerCase())
        )
      );
    }
  }, [groupSearchTerm, groups]);

  const checker = (state) => {
    const check = { icon: "check-circle", style: "null" };
    switch (state) {
      case true:
        check.icon = "check-circle";
        check.style = "correct";
        break;
      case false:
        check.icon = "times-circle";
        check.style = "wrong";
        break;
      default:
        break;
    }
    return check;
  };

  const handleGroupSelect = (group) => {
    setSelectedGroup(group);
    setForm((prev) => ({
      ...prev,
      group: { value: group.grpKey, state: true },
      brand: { value: "", state: null },
      // name: { value: prev.name.value, state: prev.name.state },
      message: { value: "", state: null },
    }));
    setGroupSearchTerm(group.name);
    setBrands(group.brands || []);
    setOutlets([]);
    setOutletStores([{ chaKey: "", storeNum: "" }]);
  };

  useEffect(() => {
    if (!form.brand.value) {
      setOutlets([]);
      setOutletStores([{ chaKey: "", storeNum: "" }]);
      return;
    }
    const brandObj = brands.find((b) => b.braKey === form.brand.value);
    if (brandObj && brandObj.chains) {
      setOutlets(brandObj.chains);
    } else {
      setOutlets([]);
    }
    setOutletStores([{ chaKey: "", storeNum: "" }]);
  }, [form.brand.value, brands]);

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "group") {
      try {
        const parsed = typeof value === "string" ? JSON.parse(value) : value;
        if (parsed && parsed.grpKey) {
          value = parsed.grpKey;
        }
      } catch {
        // value is not a JSON string, use as is
      }
      setGroupSearchTerm("");
      setSelectedGroup(null);
      setFilteredGroups(groups);
      setForm((prev) => ({
        ...prev,
        [name]: { value, state: true },
        message: { value: "", state: null },
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: { value, state: true },
        message: { value: "", state: null },
      }));
    }
  };

  // Outlet/storeNum incremental logic
  const handleOutletChange = (idx, value) => {
    setOutletStores((prev) =>
      prev.map((item, i) => (i === idx ? { ...item, chaKey: value } : item))
    );
  };

  const handleStoreNumChange = (idx, value) => {
    setOutletStores((prev) =>
      prev.map((item, i) => (i === idx ? { ...item, storeNum: value } : item))
    );
  };

  const handleAddOutlet = () => {
    setOutletStores((prev) => [...prev, { chaKey: "", storeNum: "" }]);
  };

  const handleRemoveOutlet = (idx) => {
    setOutletStores((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleReset = () => {
    setForm({
      group: { value: "", state: null },
      brand: { value: "", state: null },
      name: { value: "", state: null },
      vendorCountry: { value: "", state: null },
      vendorID: { value: "", state: null },
      vendorName: { value: "", state: null },
      message: { value: "", state: null },
      state: false,
    });
    setGroupSearchTerm("");
    setSelectedGroup(null);
    setBrands([]);
    setOutlets([]);
    setOutletStores([{ chaKey: "", storeNum: "" }]);
  };

  const isFormValid =
    form.group.value &&
    form.brand.value &&
    form.name.value &&
    form.vendorCountry.value &&
    form.vendorID.value &&
    form.vendorName.value &&
    outletStores.every(
      (item) => item.chaKey && item.storeNum && item.storeNum.trim() !== ""
    );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) return;
    try {
      // const groupObj = groups.find((g) => g.grpKey === form.group.value);
      // const brandObj = brands.find((b) => b.braKey === form.brand.value);

      const outlets = outletStores.map((item) => ({
        chaKey: item.chaKey,
        storeNum: item.storeNum,
      }));

      const CreateResponse = await axios({
        method: "POST",
        url: chimeraserv.urlPost + "/integration/create",
        headers: {
          Authorization: user.data.usrKey,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: {
          grpKey: form.group.value,
          braKey: form.brand.value,
          name: form.name.value,
          vendorID: form.vendorID.value,
          vendorName: form.vendorName.value,
          vendorCountry: form.vendorCountry.value,
          outlets: outlets,
        },
      });
      setForm((prev) => ({
        ...prev,
        message: { value: "Integration Created Successfully!", state: true },
      }));
    } catch (error) {
      setForm((prev) => ({
        ...prev,
        message: { value: "Error creating integration", state: false },
        state: false,
      }));
    }
  };

  return (
    <div className="custForm">
      <Helmet>
        <title>Create Integration | Chimera Solutions | Insights</title>
      </Helmet>
      <div className="viewTitle">Create New Integration</div>
      <form onSubmit={handleSubmit} className="form">
        <div className="form-group">
          <label>
            Name <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.name.state).style].join(" ")}
            icon={["fas", checker(form.name.state).icon]}
          />
          <input
            type="text"
            className="form-control"
            name="name"
            value={form.name.value ?? ""}
            onChange={handleChange}
            placeholder="Enter name"
          />
        </div>
        <div className="form-group">
          <label>
            VendorID <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.vendorID.state).style].join(" ")}
            icon={["fas", checker(form.vendorID.state).icon]}
          />
          <input
            type="text"
            className="form-control"
            name="vendorID"
            value={form.vendorID.value ?? ""}
            onChange={handleChange}
            placeholder="Enter VendorID"
          />
        </div>
        <div className="form-group">
          <label>
            Vendor Name <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.vendorName.state).style].join(" ")}
            icon={["fas", checker(form.vendorName.state).icon]}
          />
          <input
            type="text"
            className="form-control"
            name="vendorName"
            value={form.vendorName.value ?? ""}
            onChange={handleChange}
            placeholder="Enter Vendor Name"
          />
        </div>
        <div className="form-group">
          <label>
            vendor Country <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.vendorCountry.state).style].join(
              " "
            )}
            icon={["fas", checker(form.vendorCountry.state).icon]}
          />
          <input
            type="text"
            className="form-control"
            name="vendorCountry"
            value={form.vendorCountry.value ?? ""}
            onChange={handleChange}
            placeholder="Enter Vendor Country"
          />
        </div>
        <div className="form-group" ref={groupDropdownRef}>
          <label>
            Group <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.group.state).style].join(" ")}
            icon={["fas", checker(form.group.state).icon]}
          />
          <SearchDropdown
            data={filteredGroups}
            name="group"
            value={groupSearchTerm}
            searchTerm={groupSearchTerm}
            searchFields={["name", "grpKey"]}
            displayField="name"
            placeholder="Search business group..."
            required={true}
            showIcon={false}
            state={!!selectedGroup}
            onChange={handleChange}
            onSelect={handleGroupSelect}
            allowClear={true}
            noResultsText="No groups found"
          />
        </div>
        <div className="form-group">
          <label>
            Brand <span>*</span>
          </label>
          <FontAwesomeIcon
            className={["icon", checker(form.brand.state).style].join(" ")}
            icon={["fas", checker(form.brand.state).icon]}
          />
          <select
            className="form-control"
            name="brand"
            value={form.brand.value}
            onChange={handleChange}
            disabled={!brands.length}
          >
            <option value="">-- Select Brand --</option>
            {brands.map((b, key) => (
              <option value={b.braKey} key={key}>
                {b.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Outlets & Store Number</label>
          <div className="outlet-list">
            {outletStores.map((item, idx) => (
              <div className="outlet-row" key={idx}>
                <select
                  className="form-control"
                  value={item.outlet}
                  onChange={(e) => handleOutletChange(idx, e.target.value)}
                  disabled={!outlets.length}
                >
                  <option value="">-- Select Outlet --</option>
                  {outlets.map((o) => (
                    <option value={o.chaKey} key={o.chaKey}>
                      {o.name}
                    </option>
                  ))}
                </select>
                <input
                  type="text"
                  className="form-control"
                  value={item.storeNum ?? ""}
                  onChange={(e) => handleStoreNumChange(idx, e.target.value)}
                  placeholder="Store Number"
                />
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => handleRemoveOutlet(idx)}
                  style={{ minWidth: "2em" }}
                  disabled={outletStores.length === 1}
                >
                  &times;
                </button>
              </div>
            ))}
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleAddOutlet}
              style={{ marginTop: "1em", width: "100%" }}
              // disabled={outletStores.length > outlets.length}
            >
              + ADD
            </button>
          </div>
        </div>
        {form.message.value && (
          <div className="message form-group">{form.message.value}</div>
        )}
        <div className="form-actions">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!isFormValid}
          >
            Create
          </button>
          <button
            type="button"
            onClick={handleReset}
            className="btn btn-primary reset"
          >
            Reset
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateIntegration;
